module.exports = __webpack_public_path__ + "static/TNCG15__Global_Illumination_and_Rendering-6ec9a43df89c284809c46ebe265363ef.pdf";